import { exportRowsToExcel } from "../../utils";

export function exportTextAnalysisToExcel(data, fileName) {
  const rows = (data || []).map(item => {
    const {
      timestamp = "",
      journal_name = "",
      manuscript_id = "",
      title = "",
      numericHits = {}
    } = item || {};

    const columns = {
      Received: timestamp,
      Journal: journal_name,
      "Manuscript ID": manuscript_id,
      "Manuscript title": title,
      "Tortured phrases": numericHits.torturedPhrases || null,
      "Suspect phrases": numericHits.suspectPhrases || null,
      "GenAI Response": numericHits.genAIResponse || null,
      "Unnatural text": numericHits.unnaturalText || null,
      // "Geppetto": numericHits.geppetto || null,
      "Nonsensical text": numericHits.geppetto || null,
    };

    return columns;
  });

  exportRowsToExcel(rows, fileName);
}
